var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMulionAmodiSarasari(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.6,16h-1.7c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h1.7c0.2,0,0.4,0.2,0.4,0.4S29.8,16,29.6,16z M26.2,16h-1.7 c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h1.7c0.2,0,0.4,0.2,0.4,0.4S26.4,16,26.2,16z M22.8,16h-1.7c-0.2,0-0.4-0.2-0.4-0.4 s0.2-0.4,0.4-0.4h1.7c0.2,0,0.4,0.2,0.4,0.4S23.1,16,22.8,16z M19.5,16h-1.7c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h1.7 c0.2,0,0.4,0.2,0.4,0.4S19.7,16,19.5,16z M16.1,16h-1.7c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h1.7c0.2,0,0.4,0.2,0.4,0.4 S16.3,16,16.1,16z M12.7,16H11c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h1.7c0.2,0,0.4,0.2,0.4,0.4S13,16,12.7,16z M9.3,16H7.7 c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h1.7c0.2,0,0.4,0.2,0.4,0.4S9.6,16,9.3,16z M6,16H4.4c-0.2,0-0.4-0.2-0.4-0.4 s0.2-0.4,0.4-0.4H6c0.2,0,0.4,0.2,0.4,0.4S6.2,16,6,16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6,8.8h-1.7c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h1.7c0.2,0,0.4,0.2,0.4,0.4S29.8,8.8,29.6,8.8z M26.2,8.8h-1.7 c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h1.7c0.2,0,0.4,0.2,0.4,0.4S26.4,8.8,26.2,8.8z M22.8,8.8h-1.7c-0.2,0-0.4-0.2-0.4-0.4 s0.2-0.4,0.4-0.4h1.7c0.2,0,0.4,0.2,0.4,0.4S23.1,8.8,22.8,8.8z M19.5,8.8h-1.7c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h1.7 c0.2,0,0.4,0.2,0.4,0.4S19.7,8.8,19.5,8.8z M16.1,8.8h-1.7c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h1.7c0.2,0,0.4,0.2,0.4,0.4 S16.3,8.8,16.1,8.8z M12.7,8.8H11c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h1.7c0.2,0,0.4,0.2,0.4,0.4S13,8.8,12.7,8.8z M9.3,8.8 H7.7c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h1.7c0.2,0,0.4,0.2,0.4,0.4S9.6,8.8,9.3,8.8z M6,8.8H4.4c-0.2,0-0.4-0.2-0.4-0.4 s0.2-0.4,0.4-0.4H6c0.2,0,0.4,0.2,0.4,0.4S6.2,8.8,6,8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6,23.1h-1.7c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h1.7c0.2,0,0.4,0.2,0.4,0.4S29.8,23.1,29.6,23.1z M26.2,23.1h-1.7 c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h1.7c0.2,0,0.4,0.2,0.4,0.4S26.4,23.1,26.2,23.1z M22.8,23.1h-1.7c-0.2,0-0.4-0.2-0.4-0.4 s0.2-0.4,0.4-0.4h1.7c0.2,0,0.4,0.2,0.4,0.4S23.1,23.1,22.8,23.1z M19.5,23.1h-1.7c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h1.7 c0.2,0,0.4,0.2,0.4,0.4S19.7,23.1,19.5,23.1z M16.1,23.1h-1.7c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h1.7c0.2,0,0.4,0.2,0.4,0.4 S16.3,23.1,16.1,23.1z M12.7,23.1H11c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h1.7c0.2,0,0.4,0.2,0.4,0.4S13,23.1,12.7,23.1z  M9.3,23.1H7.7c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h1.7c0.2,0,0.4,0.2,0.4,0.4S9.6,23.1,9.3,23.1z M6,23.1H4.4 c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4H6c0.2,0,0.4,0.2,0.4,0.4S6.2,23.1,6,23.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.4,
    y: 9.1,
    width: 2,
    height: 5.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.4,
    y: 1.6,
    width: 2,
    height: 5.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.4,
    y: 16.6,
    width: 2,
    height: 5.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.4,
    y: 24.1,
    width: 2,
    height: 5.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.2,
    y: 3.8,
    width: 1,
    height: 22.3
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0,4.6 2.7,0 5.5,4.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0,25.4 2.7,30 5.5,25.4  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMulionAmodiSarasari);
export default __webpack_public_path__ + "static/media/mulion_amodi_sarasari.2a25e1b723115cf49025ae17f2a50f7b.svg";
export { ForwardRef as ReactComponent };